"use client";

let currentSessionId = 0;

/**
 * Returns the current auth session identifier.
 * Incremented whenever caches are cleared due to logout/expired token.
 */
export function getAuthSessionId(): number {
  return currentSessionId;
}

/**
 * Bumps the global auth session identifier to invalidate pending requests.
 */
export function bumpAuthSession(): number {
  currentSessionId += 1;
  return currentSessionId;
}
